import script from "./UserManager.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManager.vue?vue&type=script&setup=true&lang=js"

import "./UserManager.vue?vue&type=style&index=0&id=7ec65da9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec65da9"]])

export default __exports__